export default __webpack_public_path__ + "static/media/placeholder-male.0025ddf1.png";